import { Col, Modal, Row } from 'react-bootstrap';
import CoverImage from './CoverImage';
import L75Hmi from '../line-hmi/L75Hmi';
import L120Hmi from '../line-hmi/L120Hmi';
import DTB1250Hmi from '../line-hmi/Dtb1250Hmi.js';
import Ach300Hmi from '../line-hmi/ACH300Hmi';
import Skip2250Hmi from '../line-hmi/Skip2250Hmi';
import MeterLineHmi from '../line-hmi/MeterLineHmi';
import { feedStatus } from '../../../helpers/feedFreshness';

const MachineControlCardModal = ({ handleClose, show, machine }) => {
  const { currentPlcState } = machine;

  // This modal is the most convincing screen in the application — a full HMI
  // replica, and the one most likely to be trusted as ground truth. It used to
  // destructure `currentPlcState` and drop everything else, so the HMIs had no
  // way of knowing whether any of it was current. On 2026-09-26 that meant a
  // faithful reproduction of l120's panel, with a clock ticking, showing tag
  // values that had not changed in hours.
  const feed = feedStatus(machine);

  return (
    <Modal show={show} onHide={handleClose} size="xl" className="p-0">
      {/* <Modal.Header className="position-relative p-0 overflow-hidden">
        <CoverImage handleClose={handleClose} name={machine.machine} />
      </Modal.Header> */}
      <Modal.Body className="p-5 px-md-6 pb-md-6">
        {/* <ActionSection /> */}
        <Row className="g-5">
          <Col xs={12} xl={12}>
            <div className="mb-4">
              <h3 className="fw-bolder lh-sm text-center">
                {machine.machine.toUpperCase()}
              </h3>
              {/* One banner, above everything. A stale panel must not be read
                  as a live one, and this is the screen most likely to be
                  trusted. */}
              {feed.stale && (
                <div
                  className="alert alert-danger py-2 px-3 mt-3 mb-0 text-center fs-9 fw-bold"
                  title={feed.title}
                >
                  ⚠ PLC feed dead for {feed.label} — these are the last values
                  read, not what the line is doing now
                </div>
              )}
              {!feed.stale && feed.known && (
                <div className="text-center text-700 fs-10 mt-2">
                  PLC data {feed.label} old
                </div>
              )}
            </div>
          </Col>
        </Row>
        <Row className="g-5">
          {machine.machine === 'l75' && (
            <L75Hmi machineLive={currentPlcState} />
          )}
          {machine.machine === 'l120' && (
            <L120Hmi machineLive={currentPlcState} feed={feed} />
          )}
          {machine.machine === 'ach300' && (
            <Ach300Hmi machineLive={currentPlcState} />
          )}
          {machine.machine === 'dtb1250' && (
            <DTB1250Hmi machineLive={currentPlcState} />
          )}
          {machine.machine === 'skip2250' && (
            <Skip2250Hmi machineLive={currentPlcState} feed={feed} />
          )}
          {/* The Pi-counted lines. `dhc600` used to be tested for as `dhc800` —
              a machine that is not in the catalogue — so it rendered nothing at
              all, and `ath600` had no branch. The ids here are the ones in
              data/operatorConstants.js and in the Influx measurements. */}
          {['ath600', 'dhc600', 'l70'].includes(machine.machine) && (
            <MeterLineHmi
              machineLive={currentPlcState}
              machineId={machine.machine}
            />
          )}
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default MachineControlCardModal;
